import OrganizationCard from "./OrganizationCard";
import mayotteLaPremiereImg from "../images/1ere.svg";

function Medias() {
  const collectionPoints = [
    {
      name: "Zokweli TV",
      objective:
        "Suite au cyclone Chodi, la page facebook est mobilisée pour rapporter la situation à Mayotte en vidéos courtes, en chimaoré et français partout sur l'archipel.",
      verificationDate: "05/01/2025",
      link: "https://www.facebook.com/zokwelitv/",
      buttonText: "Cliquez ici pour accéder au site",
    },
    {
      name: "Imaz Press Réunion",
      objective:
        "Présent sur le Net depuis janvier 2000, Imaz Press Réunion est une agence de presse avec un site conçu par des journalistes rédacteurs et photographes.",
      verificationDate: "05/01/2025",
      link: "https://imazpress.com/?s=mayotte",
      buttonText: "Cliquez ici pour accéder au site",
    },
    {
      name: "LE JOURNAL DE MAYOTTE",
      objective:
        "Le JDM est né en 2013 sur le constat que la presse à Mayotte devait évoluer vers des supports numériques afin que que tout le monde puisse avoir facilement accès à l'information",
      verificationDate: "05/01/2025",
      link: "https://lejournaldemayotte.yt/",
      buttonText: "Cliquez ici pour accéder au site",
    },
    {
      name: "MAYOTTE LA PREMIERE",
      objective: "Actualités et informations en direct de Mayotte",
      verificationDate: "23/12/2024",
      //   imageUrl: mayotteLaPremiereImg,
      link: "https://la1ere.francetvinfo.fr/mayotte/",
      buttonText: "Cliquez ici pour accéder au site",
    },
  ];

  return (
    <div className="collection-points-grid">
      {collectionPoints.map((point, index) => (
        <OrganizationCard
          key={index}
          organization={point.name}
          objective={point.objective}
          verificationDate={point.verificationDate}
          imageUrl={point.imageUrl}
          link={point.link}
          buttonText={point.buttonText}
        />
      ))}
    </div>
  );
}

export default Medias;
